import { supabase } from '../config/SupabaseClient';

/**
 * Login con Supabase
 * @param {string} email - Email del usuario
 * @param {string} password - Contraseña del usuario
 * @returns {Promise<Object>} - Datos del usuario autenticado
 */
export const supabaseLogin = async (email, password) => {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      throw new Error(error.message || 'Error en el login');
    }
    // Retornar datos del usuario
    return {
      supabase_id: data.user.id,
      supabase_email: data.user.email,
      supabase_username: data.user.user_metadata?.username || data.user.email,
      supabase_role_id: data.user.user_metadata?.role_id || null,
    };
  } catch (error) {
    console.error('Error en supabaseLogin:', error);
    throw error;
  }
};


/**
 * Obtener datos del usuario actual
 * @returns {Promise<Object|null>} - Datos del usuario o null
 */
export const getCurrentUser = async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    return user || null;
  } catch (error) {
    console.error('Error obteniendo usuario actual:', error);
    return null;
  }
};

/**
 * Verificar si el usuario está autenticado
 * @returns {Promise<boolean>} - true si está autenticado
 */
export const isAuthenticated = async () => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    return !!session;
  } catch (error) {
    console.error('Error verificando autenticación:', error);
    return false;
  }
};
